import React from 'react';
import NewsletterSignup from './NewsletterSignup';
import SocialLinks from './SocialLinks';
import '../CSS/Footer.css';

import makeInIndia from '../assets/makeinindia.png';
import isoCertified from '../assets/iso.png';
import ceCertified from '../assets/ce.png';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-content">
        {/* Column 1: About */}
        <div className="footer-column">
          <h3>About MuscleCrete</h3>
          <p>Premium concrete coatings, tile adhesives, and grouts by PAC Corporation. ISO 9001-2015 & CE Certified.</p>
          <div className="footer-certifications">
            <img src={isoCertified} alt="ISO 9001-2015 Certified" title="ISO 9001-2015" />
            <img src={ceCertified} alt="CE Certified" title="CE Certified" />
            <img src={makeInIndia} alt="Made in India" title="Made in India" />
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/why-choose-us">Why Choose Us</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
            <li><a href="/faq">FAQ</a></li>
          </ul>
        </div>

        {/* Column 3: Support */}
        <div className="footer-column">
          <h3>Support</h3>
          <ul>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="tel:+91-1234567890">Phone Support</a></li>
            <li><a href="mailto:support@paccorporation.com">Email</a></li>
            <li><a href="#privacy">Privacy Policy</a></li>
            <li><a href="#terms">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Column 4: Newsletter */}
        <div className="footer-column">
          <NewsletterSignup />
        </div>
      </div>

      {/* Social Links */}
      <div className="footer-social-section">
        <h4>Follow Us</h4>
        <SocialLinks />
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; 2024 PAC Corporation. All rights reserved. | MuscleCrete - Premium Quality Products</p>
      </div>
    </div>
  </footer>
);

export default Footer;
